var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChooseStars = function SvgChooseStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FCDC7B",
    d: "M20.89 10.938a.745.745 0 0 1-1.38 0L18.34 8.07a.74.74 0 0 0-.408-.408L15.063 6.49a.745.745 0 0 1 0-1.38l2.869-1.17a.74.74 0 0 0 .408-.408L19.51.664a.745.745 0 0 1 1.38 0l1.17 2.869a.74.74 0 0 0 .408.408l2.869 1.17a.745.745 0 0 1 0 1.38l-2.869 1.17a.74.74 0 0 0-.407.409zM8.268 8.929c.414-.97 1.85-.97 2.265 0l1.924 4.508c.124.29.365.522.67.64l4.712 1.84a1.152 1.152 0 0 1 0 2.167l-4.712 1.84c-.305.12-.546.35-.67.642l-1.924 4.507c-.415.97-1.851.97-2.265 0l-1.924-4.507a1.2 1.2 0 0 0-.67-.641L.96 18.085a1.152 1.152 0 0 1 0-2.167l4.712-1.84c.305-.12.546-.35.67-.641z"
  })));
};
export default SvgChooseStars;